import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { RasterFontRealTimePreviewRequest } from '@/model';
import { loadRealTimePreviewRasterFontAPI } from '@/service';

const loadRealTimePreviewRasterFontBaseQueryKey = 'loadRealTimePreviewRasterFont';
const loadRealTimePreviewRasterFontQueryKey = (
  request: RasterFontRealTimePreviewRequest,
): string[] => [
  loadRealTimePreviewRasterFontBaseQueryKey,
  request?.text,
  String(request?.fontColor),
  String(request?.backgroundColor),
  String(request?.rasterFontId),
  String(request?.width),
  String(request?.height),
  request?.anchorX,
  request.anchorY,
  String(request?.blackAndWhite),
  String(request?.dynamicTimetableCellType),
];

const loadRealTimePreviewRasterFontFetchFunction = loadRealTimePreviewRasterFontAPI;

export const useLoadRealTimePreviewRasterFontQuery = (
  enabled: boolean,
  request: RasterFontRealTimePreviewRequest,
) => {
  return useQuery({
    queryKey: loadRealTimePreviewRasterFontQueryKey(request),
    queryFn: () => loadRealTimePreviewRasterFontFetchFunction(request),
    placeholderData: keepPreviousData,
    enabled,
  });
};
